import { ENROLLMENT_HISTORY_LATEST_LOG_EVENT_FIELDNAME, ENROLLMENT_HISTORY_LIST_FIELDNAME, FETCH_ENROLLMENT_HISTORY_LIST, FETCH_LATEST_ENROLLMENT_HISTORY_LOG_EVENT } from 'automation-ui-canvas/containers/enrollment-history/panel/queries/successfulEnrollmentsQueries';
import { useApplicationHistoryFilters } from 'automation-ui-management/hooks/filterHooks';
import { getTimestampsFromHistoryFilters } from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilterUtils';
import { useDataFetchingClient, useQuery } from 'data-fetching-client';
import { useState } from 'react';
export const useHasNewEnrollmentEvents = ({
  flowId,
  skip
}) => {
  var _newEnrollmentEvent$r, _latestEnrollmentEven;
  const [latestEnrollmentEvent, setLatestEnrollmentEvent] = useState(null);
  const variables = {
    flowId
  };
  const {
    data: {
      [ENROLLMENT_HISTORY_LATEST_LOG_EVENT_FIELDNAME]: newEnrollmentEvent = null
    } = {},
    startPolling,
    stopPolling
  } = useQuery(FETCH_LATEST_ENROLLMENT_HISTORY_LOG_EVENT, {
    variables,
    fetchPolicy: 'no-cache',
    pollInterval: 10000,
    skip
  });
  let hasNewEnrollments = false;
  if (newEnrollmentEvent && !latestEnrollmentEvent) {
    setLatestEnrollmentEvent(newEnrollmentEvent);
  } else if (newEnrollmentEvent && latestEnrollmentEvent && (newEnrollmentEvent === null || newEnrollmentEvent === void 0 || (_newEnrollmentEvent$r = newEnrollmentEvent.results) === null || _newEnrollmentEvent$r === void 0 || (_newEnrollmentEvent$r = _newEnrollmentEvent$r[0]) === null || _newEnrollmentEvent$r === void 0 ? void 0 : _newEnrollmentEvent$r.enrollmentId) !== (latestEnrollmentEvent === null || latestEnrollmentEvent === void 0 || (_latestEnrollmentEven = latestEnrollmentEvent.results) === null || _latestEnrollmentEven === void 0 || (_latestEnrollmentEven = _latestEnrollmentEven[0]) === null || _latestEnrollmentEven === void 0 ? void 0 : _latestEnrollmentEven.enrollmentId)) {
    stopPolling();
    hasNewEnrollments = true;
  }
  const resetPolling = () => {
    setLatestEnrollmentEvent(null);
    startPolling(10000);
  };
  return {
    hasNewEnrollments,
    resetPolling
  };
};
export const useEvictEnrollmentsList = () => {
  const client = useDataFetchingClient();
  const evictQueries = () => {
    client.cache.evict({
      fieldName: ENROLLMENT_HISTORY_LIST_FIELDNAME
    });
  };
  return evictQueries;
};
export const useFilteredEnrollmentsList = ({
  flowId,
  objectTypeId,
  reachedActionIds,
  hybrid,
  skip,
  seenEnrollmentIds
}) => {
  const {
    filters
  } = useApplicationHistoryFilters();
  const timeStamps = getTimestampsFromHistoryFilters(filters);
  const variables = Object.assign({
    flowId,
    isHybrid: hybrid,
    startTimestamp: timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.startTimestamp,
    endTimestamp: timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.endTimestamp
  }, filters.getObjectId() && objectTypeId ? {
    objectFilter: {
      objectTypeId,
      objectIds: [filters.getObjectId()]
    }
  } : {}, {
    reachedActionIds,
    seenEnrollmentIds
  });
  return useQuery(FETCH_ENROLLMENT_HISTORY_LIST, {
    variables,
    notifyOnNetworkStatusChange: true,
    skip: skip || !timeStamps || !(timeStamps !== null && timeStamps !== void 0 && timeStamps.startTimestamp) || !!(timeStamps !== null && timeStamps !== void 0 && timeStamps.endTimestamp) && timeStamps.startTimestamp > timeStamps.endTimestamp
  });
};